import { TopologyItem } from "objs/_ConfiguratorObjs/Wizard/SubComponents/WizardResult/TopologyItem";
import React, { useEffect } from "react";
import { DragItem } from "objs/_ConfiguratorObjs/Wizard/SubComponents/WizardResult/DragItem";
import { useDrag } from "react-dnd";
import { ItemTypes } from "objs/_ConfiguratorObjs/Wizard/SubComponents/WizardResult/DndTypes";
import { getEmptyImage } from "react-dnd-html5-backend";
import cx from "classnames";

export const Module = (props) => {
  const [{ isDragging }, dragRef, preview] = useDrag(
    () => ({
      type: ItemTypes.Module,
      item: { ...props },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [],
  );

  useEffect(() => {
    preview(getEmptyImage(), { captureDraggingState: true });
  }, [preview]);

  return (
    <TopologyItem
      {...props}
      classNames={cx({ "opacity-50": isDragging })}
      dragItem={
        <DragItem kind={props?.kind} iconName={props.iconName} ref={dragRef} />
      }
    />
  );
};
